module.exports = __webpack_public_path__ + "static/img/64.17de767.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/64.png
// module id = 3Kca
// module chunks = 1